import type {
  RevaluatedInputData,
  TableRevaluatedData
} from './revaluation.types'

export const getRevaluatedRestDuration = (
  revaluatedInputData: RevaluatedInputData,
  revaluatedData: TableRevaluatedData[]
): number => {
  const revaluatedInputDataArray = Object.values(revaluatedInputData)

  const completeWeeksHours = revaluatedData
    .filter(({ is_complete_week: isCompleteWeek }) => isCompleteWeek)
    .reduce((mem, { contract_time: contractTime }) => mem + contractTime, 0)

  const reducedValuatedInputData = revaluatedInputDataArray.length
    ? revaluatedInputDataArray.reduce((mem, { value }) => {
        return Number(mem) + Number(value)
      }, 0)
    : 0

  return revaluatedData.length === 1
    ? Number(reducedValuatedInputData)
    : Number(completeWeeksHours) + Number(reducedValuatedInputData)
}
